// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"ModalContent-modalContent--txrl","closeButton":"ModalContent-closeButton-37Puk"};